var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#146EB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1619 20.7615C44.1773 19.7462 45.8235 19.7462 46.8389 20.7615C47.7761 21.6988 47.8482 23.1736 47.0552 24.1935L46.8389 24.4385L28.9639 42.3135C28.0266 43.2507 26.5518 43.3228 25.5319 42.5298L25.2869 42.3135L17.1619 34.1885C16.1465 33.1731 16.1465 31.5269 17.1619 30.5115C18.0992 29.5743 19.574 29.5022 20.5939 30.2952L20.8389 30.5115L27.1254 36.796L43.1619 20.7615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckCircle);
export default __webpack_public_path__ + "static/media/blue_check_circle.86e881fe58da32ecea0e87feda5c1c07.svg";
export { ForwardRef as ReactComponent };